var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'flowbite-react';
import { Button, Pill } from "../../../../Components/UI";
import { t, Translate } from "../../../../../I18N";


const UsernameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Username");
const GroupNameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const ProtectionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Protection");
const RoleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Role");
const GroupsHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Group");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");
const MembersHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Members");

const ProtectionPill = ({ cell }) => {
  if (cell.getValue()) {
    return /*#__PURE__*/(
      _jsx(Pill, { color: "green", className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Password + 2fa")
      ));

  }
  return /*#__PURE__*/(
    _jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Password")
    ));

};

const RolePill = ({ cell }) => {
  const value = cell.getValue();
  return /*#__PURE__*/(
    _jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Pill, { color: value === 'admin' ? 'primary' : 'gray' }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, value)
    )
    ));

};

const MembersPill = ({
  cell
}) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((member) => /*#__PURE__*/
_jsx("div", {}, member.username, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, member.username)
)
)
);


const GroupsPill = ({ cell }) => {var _cell$getValue;return /*#__PURE__*/(
    _jsx("div", { className: "flex flex-wrap gap-2" }, void 0, (_cell$getValue =
    cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.map((group) => /*#__PURE__*/
    _jsx("div", {}, cell.id + group._id, /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "whitespace-nowrap" }, void 0,
    group.name
    )
    )
    )
    ));};


const UsernameCell = ({ cell }) => {
  const userIsBlocker = cell.row.original.accountLocked;
  return /*#__PURE__*/(
    _jsx("div", { className: "flex items-start gap-1" }, void 0, /*#__PURE__*/
    _jsx("span", { className: userIsBlocker ? 'text-red-600' : '' }, void 0, cell.getValue()),
    userIsBlocker && /*#__PURE__*/
    _jsx(Tooltip, {
      content: t('System', 'Account locked', null, false)
      // eslint-disable-next-line react/style-prop-object
      , style: "light" }, void 0, /*#__PURE__*/

    _jsx(LockClosedIcon, { className: "w-4 text-red-600 cursor-pointer" })
    )

    ));

};

const EditButton = ({ onClick }) => /*#__PURE__*/
_jsx(Button, { styling: "outline", onClick: onClick, className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Edit")
);


const EditUserButton = ({ cell }) => {
  const selectedUser = cell.row.original;
  return /*#__PURE__*/_jsx(EditButton, { onClick: () => {var _cell$column$columnDe, _cell$column$columnDe2;return (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : (_cell$column$columnDe2 = _cell$column$columnDe.action) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.call(_cell$column$columnDe, selectedUser);} });
};

const EditUserGroupButton = ({ cell }) => {
  const selectedUserGroup = cell.row.original;
  return /*#__PURE__*/_jsx(EditButton, { onClick: () => {var _cell$column$columnDe3, _cell$column$columnDe4;return (_cell$column$columnDe3 = cell.column.columnDef.meta) === null || _cell$column$columnDe3 === void 0 ? void 0 : (_cell$column$columnDe4 = _cell$column$columnDe3.action) === null || _cell$column$columnDe4 === void 0 ? void 0 : _cell$column$columnDe4.call(_cell$column$columnDe3, selectedUserGroup);} });
};

const getUsersColumns = (editButtonAction) => {
  const columnHelper = createColumnHelper();
  return [
  columnHelper.accessor('username', {
    header: UsernameHeader,
    cell: UsernameCell,
    meta: { className: 'w-1/3' }
  }),
  columnHelper.accessor('using2fa', {
    header: ProtectionHeader,
    cell: ProtectionPill,
    meta: { className: 'w-0' }
  }),
  columnHelper.accessor('role', {
    header: RoleHeader,
    cell: RolePill,
    meta: { className: 'w-0' }
  }),
  columnHelper.accessor('groups', {
    header: GroupsHeader,
    cell: GroupsPill,
    meta: { className: 'w-2/3' }
  }),
  columnHelper.display({
    id: '1',
    header: ActionHeader,
    cell: EditUserButton,
    meta: { action: editButtonAction, className: 'w-0 text-center' },
    enableSorting: false
  })];

};

const getGroupsColumns = (editButtonAction) => {
  const columnHelper = createColumnHelper();
  return [
  columnHelper.accessor('name', {
    header: GroupNameHeader,
    meta: { className: 'w-1/4' }
  }),
  columnHelper.accessor('members', {
    header: MembersHeader,
    cell: MembersPill,
    enableSorting: false,
    meta: { className: 'w-3/4' }
  }),
  columnHelper.display({
    id: '1',
    header: ActionHeader,
    cell: EditUserGroupButton,
    meta: { action: editButtonAction, className: 'w-0 text-center' },
    enableSorting: false
  })];

};

export { getUsersColumns, getGroupsColumns };